import { z } from "zod";

const AudienceGroupSchema = z.object({
	id: z.number(),
	name: z.string()
});

export const ObservationCategoryOutputSchema = z.object({
	id: z.number(),
	uuid: z.string().uuid(),
	name: z.string(),
	createdAt: z.string().datetime(),
	updatedAt: z.string().datetime(),
	publishedFormsCount: z.number(),
	draftFormsCount: z.number(),
	// Backend may serialise an empty audience as `null`, `undefined`, or omit
	// the field entirely — normalise all three to `[]` so admin screens render.
	audienceGroups: z
		.array(AudienceGroupSchema)
		.nullish()
		.transform((v) => v ?? [])
});

export const ObservationCategoriesSchema = z.array(
	ObservationCategoryOutputSchema
);

export type ObservationCategoryModel = z.infer<
	typeof ObservationCategoryOutputSchema
>;
